import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import { store } from './store'
import { LoginPromptProvider } from './context/LoginPromptContext'
import { ToastProvider } from './context/ToastContext'
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <GlobalErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <HelmetProvider>
          <LoginPromptProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </LoginPromptProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  </GlobalErrorBoundary>,
)
